/*
  Smooth in-page jumps.

  Any element with `data-scroll-to="<selector>"` scrolls the page to the first
  element matching that selector. Nothing else is required of the markup, so
  the same handler covers whatever else wants this later - it is bound once on
  the document rather than per button, so sections rendered by the theme editor
  after load are covered too.

  Kept out of smooth-scroll.js on purpose: that file returns early when the
  visitor asks for reduced motion, and this still has a job to do in that case.
  It just does it instantly.
*/
(function () {
  /* Clearance under the sticky header, so the heading isn't tucked behind it. */
  var HEADROOM = 24;

  /*
    Distance-scaled: a fixed duration either crawls across a short gap or
    rockets across the length of a product page. Between 0.9s and 1.8s reads as
    deliberate travel at any distance - long enough to show the reader they are
    being moved down the page rather than teleported, short enough not to feel
    like waiting.
  */
  var MIN_SECONDS = 0.9;
  var MAX_SECONDS = 1.8;
  var PIXELS_PER_SECOND = 2200;

  /* The standard ease-in-out cubic: settles at both ends, no overshoot. */
  function easeInOutCubic(t) {
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
  }

  /* header.liquid keeps this in sync with the real header height. */
  function headerClearance() {
    var declared = window
      .getComputedStyle(document.documentElement)
      .getPropertyValue('--header-height');
    var height = parseFloat(declared);
    return (isNaN(height) ? 0 : height) + HEADROOM;
  }

  document.addEventListener('click', function (event) {
    if (!event.target || !event.target.closest) return;

    var trigger = event.target.closest('[data-scroll-to]');
    if (!trigger) return;

    var target = document.querySelector(trigger.getAttribute('data-scroll-to'));
    /*
      No target on this page - a template without the section, say - so leave
      the click alone. A link still follows its href, a button still does
      nothing, and either is better than a dead handler that swallowed it.
    */
    if (!target) return;

    event.preventDefault();

    var offset = -headerClearance();
    var travel = Math.abs(target.getBoundingClientRect().top + offset);

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      window.scrollTo({ top: window.pageYOffset + target.getBoundingClientRect().top + offset });
      return;
    }

    var seconds = Math.min(MAX_SECONDS, Math.max(MIN_SECONDS, travel / PIXELS_PER_SECOND));

    if (window.lenis) {
      /*
        Handing it to Lenis rather than to the browser keeps one thing moving
        the page. A native smooth scroll would animate the same scroll position
        Lenis is easing, and the two fight for it.
      */
      window.lenis.scrollTo(target, {
        offset: offset,
        duration: seconds,
        easing: easeInOutCubic,
      });
    } else {
      window.scrollTo({
        top: window.pageYOffset + target.getBoundingClientRect().top + offset,
        behavior: 'smooth',
      });
    }
  });
})();
